
import React, { memo } from "react";
import { Skeleton } from "@/components/ui/skeleton";

interface LoadingPageProps {
  message?: string;
}

// Optimized for faster renders with fewer animations
export const LoadingPage = memo(({ message }: LoadingPageProps) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[40vh] p-4">
      {message && <p className="text-sm text-muted-foreground mb-2">{message}</p>}
      <div className="w-full max-w-md space-y-2">
        {/* Reduced number of animations to improve performance */}
        <div className="flex items-center justify-center mb-4">
          <div className="h-8 w-8 border-2 border-primary/30 border-t-primary rounded-full animate-spin"></div>
        </div>
        <Skeleton className="h-4 w-full opacity-40" />
        <Skeleton className="h-4 w-3/4 opacity-40" />
      </div>
    </div>
  );
});

LoadingPage.displayName = "LoadingPage";
